import React from "react";
import "../../../css/TotalWeekRental.css";
import {
  ComposedChart,
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  Bar,
  ResponsiveContainer,
} from "recharts";

interface TotalWeekRentalProps {
  TotalWeekRental: { week: string; count: number }[];
}

const TotalWeekRental = ({ TotalWeekRental }: TotalWeekRentalProps) => {
  return (
    <div className="week_total_rental_container">
      <h2 className="week_total_rental_title">曜日別レンタル件数(累計)</h2>
      <ResponsiveContainer height="70%" width="90%">
        <ComposedChart
          height={300}
          data={TotalWeekRental}
          className="bar_chart">
          <XAxis dataKey="week" />
          <YAxis dataKey="count" />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#f5f5f5" />
          <Bar
            dataKey="count"
            barSize={20}
            stroke="rgba(34, 80, 162, 0.2)"
            fillOpacity={1}
            fill="#4cceac"
            name="レンタル件数"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TotalWeekRental;
